export default __webpack_public_path__ + "static/media/logo.e802a798.png";